module.exports = __webpack_public_path__ + "static/img/j_2@2x.8f4a46b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/j_2@2x.png
// module id = mgmi
// module chunks = 2